import { render, staticRenderFns } from "./imgSwipper.vue?vue&type=template&id=469e9d70&"
import script from "./imgSwipper.vue?vue&type=script&lang=js&"
export * from "./imgSwipper.vue?vue&type=script&lang=js&"
import style0 from "./imgSwipper.vue?vue&type=style&index=0&id=469e9d70&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports